<div class="form-horizontal">
  <div class="row tabs-cont" #tabsCont>
    <div class="col-md-12 h-100" style="padding-top: 10px;">
      <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false" id="tabset">
        <ngb-tab title="{{'PODESAVANJEKLJUCEVA.KLJUC.PLURAL'| translate}}" id="tbOrgJedDefgini" *ngIf="hasUserRights">
           <ng-template ngbTabContent>
            <form [formGroup]="formGroup" #f="ngForm" class="mt-4 pl-2">
              <table>
                <thead>
                  <tr>
                    <th>NAZIV</th>
                    <th>TIP</th>
                    <th>VREDNOST</th>
                    <th>OPIS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let res of result">
                    <td style="padding-right: 20px">{{ res.Naziv }}</td>
                    <td style="padding-right: 20px">{{ res.Tip }}</td>
                    <td [ngSwitch]="res.Tip" style="padding-right: 20px">
                      <div *ngSwitchCase = "'bit'"><input type="checkbox" [formControlName]="res.Naziv" (change)="onVrednostChange($event.target.checked, res.Naziv)"></div>
                      <div *ngSwitchCase = "'int'"><yt-number-input-v3 [formControlName]="res.Naziv" (OnBlur)="onVrednostChange($event, res.Naziv)"></yt-number-input-v3></div>
                      <div *ngSwitchCase = "'nvarchar'"><yt-input [Type]="'text'" [formControlName]="res.Naziv" (OnBlur)="onVrednostChange($event, res.Naziv)"></yt-input></div>
                    </td>
                    <td>{{ res.Opis }}</td>
                  </tr>
                </tbody>
               </table>
              </form>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="{{'USERPROVAJDER.PLURAL'| translate}}" id="tbUserProvajder">
          <ng-template ngbTabContent>
            <form [formGroup]="formGroupProvajder" #f="ngForm" class="mt-4 pl-2">
              <div>
                <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
                  <div class="row">
                    <div class="col-md-12">
                      <yt-userprovajder-update-container
                        #baseInlineContainer
                        [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'OrgJedId'" [ParentPropertyValue]="Item.ID"
                      >
                      </yt-userprovajder-update-container>
                    </div>
                  </div>
                </form>
              </div>
            </form>
          </ng-template>
        </ngb-tab>
        <ngb-tab title="{{'USER.IPADDRESS.PLURAL'| translate}}" id="tbUserIpAdress" *ngIf="hasUserRightsIpAdress">
          <ng-template ngbTabContent>
            <form [formGroup]="formGroupIpAdress" #f="ngForm" class="mt-4 pl-2">
              <div>
                <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
                  <div class="row">
                    <div class="col-md-12">
                      <yt-useripadress-update-container
                      #baseInlineContainer1
                       [DetailModelData]="modelData.MainList.DetailList[1]" 
                       [ParentPropertyName]="'OrgJedId'" 
                       [ParentPropertyValue]="Item.ID">
                      </yt-useripadress-update-container>
                      <!-- <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[1]" [ParentPropertyName]="'OrgJedId'" [ParentPropertyValue]="Item.ID"></yt-fw-default-detail-list-modal> -->
                    </div>
                  </div>
                </form>
              </div>
            </form>
          </ng-template>
        </ngb-tab>
    </ngb-tabset>
    </div>
  </div>
</div>

